export function getGoogleMapsBrowserApiKey(): string {
  return [
    import.meta.env.VITE_GOOGLE_MAPS_BROWSER_API_KEY,
    import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  ].reduce<string>((apiKey, value) => apiKey || String(value || '').trim(), '')
}
